import React, { useState } from 'react'
import SiteUsers from './component'
import { inputModeType } from '../../lib/util'

const Container = props => {
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false)
  const {
    addBulkUsersResponse,
    isBulkOperationCompleted,
    siteUsers,
    createSiteUser,
    createSiteUsers,
    remindSiteUser,
    remindSiteUsers,
    resetBulkAddUsers,
    error,
    selectedSite,
    handleCancelUserAccess,
    handleGrantNewRole,
  } = props || {}

  const { id } = selectedSite || ''
  const handleOpenAddUsersModal = () => setIsAddUserModalOpen(true)
  const handleCloseAddUsersModal = () => {
    resetBulkAddUsers()
    setIsAddUserModalOpen(false)
  }

  const handleSubmitAddUsers = async (
    emails,
    role,
    sendNotification,
    inputMode,
  ) => {
    const addSiteUsers = emails.map(email => ({
      inviteEmail: email.trim(),
      isActive: true,
      roles: [role],
      siteId: id,
    }))
    if (inputMode === inputModeType.bulk) {
      await createSiteUsers(id, addSiteUsers, sendNotification)
    } else {
      await createSiteUser(addSiteUsers[0], sendNotification, selectedSite)
      resetBulkAddUsers()
      setIsAddUserModalOpen(false)
    }
  }

  return (
    <SiteUsers
      key={id}
      addBulkUsersResponse={addBulkUsersResponse}
      handleCancelUserAccess={handleCancelUserAccess}
      handleGrantNewRole={handleGrantNewRole}
      isBulkOperationCompleted={isBulkOperationCompleted}
      siteUsers={siteUsers}
      site={selectedSite}
      handleCloseAddUsersModal={handleCloseAddUsersModal}
      handleOpenAddUsersModal={handleOpenAddUsersModal}
      handleSubmitAddUsers={handleSubmitAddUsers}
      isAddUserModalOpen={isAddUserModalOpen}
      remindSiteUser={remindSiteUser}
      remindSiteUsers={remindSiteUsers}
      error={error}
      selectedSite={selectedSite}
    />
  )
}

export default Container



// WEBPACK FOOTER //
// ./src/components/SiteUsers/container.js